export { default } from './Chip';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Chip/index.js
// module id = 582
// module chunks = 121